<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-noisecatalog-home">
      <div class="flex-container row flex-align-center">
        <div class="bmw-lg-noisecatalog-home-title flex-65">
          Noise Catalog
        </div>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex">
          <form form #formnoisecatalogfiltersearch="ngForm" style="width:93%;"
            class="myForm input-group" name="findDocs">
            <div class="flex-container row myForm-row flex-align-center">
              <div class="column" style=" display: flex;flex-direction: column;">
                <div class="flex-50">
                  <div class="input-group" style="display: flex;">
                    <label for="mainGroup" style=" padding: .5em 2em .5em 0;flex: 2;">Main Group</label>
                    <select class="form-control" #mainGroupField="ngModel" id="mainGroup" name="mainGroup"
                      [(ngModel)]='inputChannel' style=" flex: 3; ">
                      <option ngValue="undefined" selected> Select</option>
                      <option *ngFor="let mainGroup of channelsList" [ngValue]="mainGroup"> [ {{ mainGroup?.mainGroupNumber }}  ] {{mainGroup?.mainGroupName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column" style=" display: flex;flex-direction: column;">
                <div class="flex-50">
                  <div class="input-group" style=" display: flex;">
                    <label for="sporadicPermanent">Sporadic or Permanent</label>
                    <select class="form-control" #sporadicPermanentField="ngModel" id="sporadicPermanent"
                      name="sporadicPermanent" [(ngModel)]='inputSproadicPermanent' style=" flex: 3;">
                      <option ngValue="undefined" selected> Select</option>
                      <option *ngFor="let sproadicPermanent of sproadicPermanentList" [ngValue]="sproadicPermanent">
                        {{sproadicPermanent}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectSeries" style=" padding: .5em 0 .5em 0;flex: 2;">E Series</label>
                  <ng-multiselect-dropdown #multiSelectSeries id="multiSelectSeries" name="multiSelectSeries"
                    [placeholder]="'Select'" [data]="dropdownESeriesList" [(ngModel)]="seriesFilterList"
                    [settings]="dropdownSettingsSeries" [disabled]="false"
                    (onSelect)='addToNoiseSelection("series",$event)'
                    (onDeSelect)='removeFromNoiseSelection("series",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectArea" style=" padding: .5em 0 .5em 0;flex: 2;">Area</label>
                  <ng-multiselect-dropdown #multiSelectArea id="multiSelectArea" name="multiSelectArea"
                    [placeholder]="'Select'" [data]="dropdownAreaList" [(ngModel)]="areaFilterList"
                    [settings]="dropdownSettings" (onSelect)='addToNoiseSelection("area",$event)'
                    (onDeSelect)='removeFromNoiseSelection("area",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectComponent" style=" padding: .5em 0 .5em 0;flex: 2;">Component</label>
                  <ng-multiselect-dropdown #multiSelectComponent id="multiSelectComponent" name="multiSelectComponent"
                    [placeholder]="'Select'" [data]="dropdownComponentList" [(ngModel)]="componentFilterList"
                    [settings]="dropdownSettings" (onSelect)='addToNoiseSelection("component",$event)'
                    (onDeSelect)='removeFromNoiseSelection("component",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectDrivingCondition" style=" padding: .5em 0 .5em 0;flex: 2;">Driving
                    Conditions</label>
                  <ng-multiselect-dropdown #multiSelectDrivingCondition id="multiSelectDrivingCondition"
                    name="multiSelectDrivingCondition" [placeholder]="'Select'" [data]="dropdownDrivingConditionList"
                    [(ngModel)]="drivingConditionFilterList" [settings]="dropdownSettings"
                    (onSelect)='addToNoiseSelection("drivingCondition",$event)'
                    (onDeSelect)='removeFromNoiseSelection("drivingCondition",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectWeatherCondition" style=" padding: .5em 0 .5em 0;flex: 2;">Weather
                    Conditions</label>
                  <ng-multiselect-dropdown #multiSelectWeatherCondition id="multiSelectWeatherCondition"
                    name="multiSelectWeatherCondition" [placeholder]="'Select'" [data]="dropdownWeatherConditionList"
                    [(ngModel)]="weatherConditionFilterList" [settings]="dropdownSettings"
                    (onSelect)='addToNoiseSelection("weatherCondition",$event)'
                    (onDeSelect)='removeFromNoiseSelection("weatherCondition",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="flex-container row flex-align-center myForm-row">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectKindOfNoise" style=" padding: .5em 0 .5em 0;flex: 2;">Kind of Noise</label>
                  <ng-multiselect-dropdown #multiSelectKindOfNoise id="multiSelectKindOfNoise"
                    name="multiSelectKindOfNoise" [placeholder]="'Select'" [data]="dropdownKindOfNoiseList"
                    [(ngModel)]="kindOfNoiseFilterList" [settings]="dropdownSettings"
                    (onSelect)='addToNoiseSelection("kindOfNoise",$event)'
                    (onDeSelect)='removeFromNoiseSelection("kindOfNoise",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="form-row">
              <button type="submit" (click)='populateFilteredNoiseCatalogList()'>Search</button>
            </div>
          </form>
          <br />
        </div>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex-65">
          <span *ngIf='newNoisecatalog?.length <=0 && searchClick===true'>
            <small style="font-size:16px;font-weight:normal;color: red">No results found for the given search
              criteria</small>
          </span>
        </div>
        <div class="bmw-lg-noisecatalog-home-title flex">
          <form #formnoisecatalogkeywordsearch="ngForm" style="width:70%;" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Find Noise Catalog" name="techDoc" [(ngModel)]="search4noisecatalog">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div>
        <div class="row bmw-no-gutter">
          <div
            *ngFor='let noisecatalog of newNoisecatalog | searchFilter: "noiseCatalogId,noiseCatalogDisplayId,noiseCatalogDisplayNumber,noiseCatalogTitle,noiseCatalogVimeoId": search4noisecatalog | loadMoreItems: moreItems'>
            <div style="float: left; margin-right: 60px;user-select: none">
              <div class="pointer bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
                [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
                <img src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
                <div class="bmw-lg-noisecatalog-home-overlay-text"></div>
              </div>
              <div class="bmw-lg-noisecatalog-metadata" style="width: 220px; height: 80px">
                <div class="row bmw-no-gutter">
                  <div class="col-lg-10 bmw-no-gutter">
                    <div class="row bmw-no-gutter">{{noisecatalog.noiseCatalogDisplayNumber}}</div>
                    <div class="row bmw-no-gutter"
                      [innerHTML]='noisecatalog.noiseCatalogTitle.length > 43 ?noisecatalog.noiseCatalogTitle.substr(0,40)+"..." :noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
                    </div>
                    <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                      {{noisecatalog.releaseDate | date: 'yyyy-MM-dd'}} {{noisecatalog.views}} views
                    </div>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons pointer" style="opacity: 0.7"
                      data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer"
                        (click)='addNoiseCatalogToWatchlist(noisecatalog?.noiseCatalogId, noisecatalog?.noiseCatalogDisplayNumber)'>
                        <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                          <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Add to watchlist
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
                        (click)='noisecatalogshareContent(noisecatalog?.noiseCatalogId, "noisecatalog",noisecatalog.mainGroup.mainGroupNumber, noisecatalog?.noiseCatalogDisplayNumber)'>
                        <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                          <i class="material-icons dp48" style="font-size:20px">share</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Share
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter">
                        <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bmw-video-playback-showmore-button bmw-button-secondary pointer"
          (click)='moreItems = moreItems + 24' *ngIf='newNoisecatalog?.length > 24'>
          <label style="margin-top: 5px">Show More</label>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div *ngIf='screenWidth > 991 && screenWidth < 1098'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-noisecatalog-home md">
      <div class="flex-container row flex-align-center">

        <div class="flex">
          <form style="width:90%;" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Keyword search" name="techDoc" [(ngModel)]="search4noisecatalog">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div>
        <div
          *ngFor='let noisecatalog of newNoisecatalog | searchFilter: "noiseCatalogId,noiseCatalogDisplayId,noiseCatalogDisplayNumber,noiseCatalogTitle,noiseCatalogVimeoId": search4noisecatalog | loadMoreItems: moreItems'>
          <div class="pointer" style="float: left; margin-right: 12px;user-select: none">
            <div class="pointer bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup: noisecatalog.mainGroup.mainGroupNumber, noisecatalog: noisecatalog.noiseCatalogId,vimeoID: noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
              <div class="bmw-lg-noisecatalog-home-overlay-text"></div>
            </div>
            <div class="bmw-lg-noisecatalog-metadata" style="width: 220px; height: 80px">
              <div class="row bmw-no-gutter">
                <div class="col-md-10 bmw-no-gutter">
                  <div class="row bmw-no-gutter">{{noisecatalog.noiseCatalogDisplayNumber}}</div>
                  <div class="row bmw-no-gutter"
                    [innerHTML]='noisecatalog.noiseCatalogTitle.length > 50 ? noisecatalog.noiseCatalogTitle.substr(0,50)+"..." : noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
                  </div>
                  <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                    {{noisecatalog.releaseDate | date: 'yyyy-MM-dd'}} {{noisecatalog.views}}
                  </div>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons pointer" style="opacity: 0.7"
                    data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addNoiseCatalogToWatchlist(noisecatalog?.noiseCatalogId, noisecatalog?.noiseCatalogDisplayNumber)'>
                      <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent">
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bmw-video-playback-showmore-button bmw-button-secondary pointer"
          (click)='moreItems = moreItems + 24' *ngIf='newNoisecatalog?.length > 24'>
          <label style="margin-top: 5px">Show More</label>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-noisecatalog-home sm">
      <div class="flex-container row flex-align-center">
        <div class="flex">
          <form style="width:90%" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Keyword search" name="techDoc" [(ngModel)]="search4noisecatalog">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="bmw-xs-noisecatalog">
        <div class="alert alert-danger" *ngIf="!newNoisecatalog">{{serviceError}}</div>
        <div class="row bmw-no-gutter"
          *ngFor='let noisecatalog of newNoisecatalog | searchFilter: "noiseCatalogId,noiseCatalogDisplayId,noiseCatalogDisplayNumber,noiseCatalogTitle,noiseCatalogVimeoId": search4noisecatalog | loadMoreItems: moreItems '
          style="margin-bottom:7px">
          <div class="col-sm-4 bmw-no-gutter bmw-sm-noisecatalog-home-thumbnail">
            <a [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup: noisecatalog.mainGroup.mainGroupNumber, noisecatalog: noisecatalog.noiseCatalogId,vimeoID: noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
              <img src="{{videoThumbnail}}" width="50px" height="50px" />
              <!-- <video height="84px" width="150px" [src]='noisecatalogId?.noisecatalogIdFileName'></noisecatalogId> -->
            </a>
          </div>
          <div class="col-sm-6 bmw-no-gutter" style="padding-left: 15px">
            <div class="row bmw-no-gutter"
              [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'>
            </div>
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
            </div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
              <div class="col-sm-6 bmw-no-gutter"
                [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div class="col-sm-6 bmw-no-gutter" [innerHTML]='noisecatalog.views'></div>
            </div>
          </div>
          <div class="col-sm-1 bmw-no-gutter">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addNoiseCatalogToWatchlist(noisecatalog?.noiseCatalogId, noisecatalog?.noiseCatalogDisplayNumber)'>
                  <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter" data-toggle="modal" data-target="#noisecatalogshareContent">
                  <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="bmw-video-playback-showmore-button bmw-button-secondary pointer"
          (click)='moreItems = moreItems + 24' *ngIf='newNoisecatalog?.length > 24'>
          <label style="margin-top: 5px">Show More</label>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-noisecatalog-home">

      <div class="flex-container row">
        <form style="width:90%; margin: auto; margin-bottom: 25px" class="input-group" name="findDocs">
          <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
            placeholder="Find Noisecatalog" name="techDoc" [(ngModel)]="search4noisecatalog">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true')}"
              class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div class="bmw-xs-results-content-service-bulletins">
        <div class="alert alert-danger" *ngIf="!newNoisecatalog">{{serviceError}}</div>
        <div class="row bmw-no-gutter"
          *ngFor='let noisecatalog of newNoisecatalog | searchFilter: "noiseCatalogId,noiseCatalogDisplayId,noiseCatalogDisplayNumber,noiseCatalogTitle,noiseCatalogVimeoId": search4noisecatalog | loadMoreItems: moreItems'
          style="margin-bottom:7px">
          <div class="col-xs-4 bmw-no-gutter bmw-xs-noisecatalog-home-thumbnail">
            <a [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup: noisecatalog.mainGroup.mainGroupNumber, noisecatalog: noisecatalog.noiseCatalogId,vimeoID: noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
              <img src="{{videoThumbnail}}" width="50px" height="50px" />
              <!-- <noisecatalogId height="84px" width="150px" [src]='noisecatalogId?.noisecatalogIdFileName'></noisecatalogId> -->
            </a>
          </div>
          <div class="col-xs-6 bmw-no-gutter">
            <div class="row bmw-no-gutter"
              [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'>
            </div>
            <div class="row bmw-no-gutter"
              [innerHTML]='noisecatalog.noiseCatalogTitle.length > 19 ? noisecatalog.noiseCatalogTitle.substr(0,20)+"..." : noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
            </div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
              <div class="col-xs-6 bmw-no-gutter"
                [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div class="col-xs-6 bmw-no-gutter" [innerHTML]='noisecatalog.views'></div>
            </div>
          </div>
          <div class="col-xs-1 bmw-no-gutter">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addNoiseCatalogToWatchlist(noisecatalog?.noiseCatalogId, noisecatalog?.noiseCatalogDisplayNumber)'>
                  <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent">
                  <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="bmw-video-playback-showmore-button bmw-button-secondary pointer"
          (click)='moreItems = moreItems + 24' *ngIf='newNoisecatalog?.length > 24'>
          <label style="margin-top: 5px">Show More</label>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>